// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_a9bd2d69","quoteWrapper":"_a095f973","openQuote":"_33339e74","closeQuote":"_c90141f6","quoteBody":"_e80ef930","image":"_8c369edd","author":"_9e9f874f"};